import React, { Component, useState, useEffect } from "react";
import swal from "sweetalert";
import Baseurl from "../../../Baseurl";
import axios from "axios";
import {
  Row,
  Card,
  Col,
  Button,
  Nav,
  Modal,
  Table,
  Dropdown,
  Alert,
  Spinner,
} from "react-bootstrap";
import { useHistory } from "react-router-dom";
export default function CustomerSupport() {
  const history=useHistory()
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [emailUpdate, setEmailUpdate] = useState("");
  const [phoneUpdate, setPhoneUpdate] = useState("");
  const [show, setShow] = useState(false);
  const [addStatus, setAddStatus] = useState(false);
  const [deleteStatus, setDeleteStatus] = useState(false);
  const [supportData, setSupportData] = useState("");
  const [supportId, setSupportId] = useState("");

  function getData() {
    axios.get(Baseurl.baseurl + `/support-tech/get-all-tech-support`).then((res) => {
      setSupportData(res.data.details);
      if(res.data.details.length==1){
        setAddStatus(false)
      }
      else
      {
        setAddStatus(true)
      }
    })
    .catch((err) => {
      if(err.toString()==="Error: Network Error")
      {
        history.push('/offline')
      }
      else
      {
        history.push('/400')
      }
  })
  }
  useEffect(() => {
    getData();
  }, []);
  function addSupport(e) {
    e.preventDefault();
    let values = {
      Phone: phone,
      Email: email,
    };
    axios
      .post(Baseurl.baseurl + `/support-tech/add-support`, values)
      .then((response) => {
        if (response.data.status) {
          swal("Added", response.data.message, "success", { button: "Done",timer: 1000 });
          getData();
          setEmail("");
          setPhone("");
        } else {
          swal("Oops", response.data.message, "error", { button: "Done",timer: 1000 });
        }
      })
      .catch((err) => {
        if(err.toString()==="Error: Network Error")
        {
          history.push('/offline')
        }
        else
        {
          history.push('/400')
        }
    })
  }
  function updateSupport(e) {
    e.preventDefault();
    let values = {
      Phone: phoneUpdate,
      Email: emailUpdate,
    };
    axios
      .put(
        Baseurl.baseurl + `/support-tech/update-support/${supportId}`,
        values
      )
      .then((response) => {
        if (response.data.status) {
          swal("Added", response.data.message, "success", { button: "Done",timer: 1000 });
          getData();
          setShow(false);
        } else {
          
          swal("Oops", response.data.message, "error", { button: "Done",timer: 1000 });
        }
      })
      .catch((err) => {
        if(err.toString()==="Error: Network Error")
        {
          history.push('/offline')
        }
        else
        {
          history.push('/400')
        }
    })
  }
  function deleteSupport(){
    axios
      .put(Baseurl.baseurl +`/support-tech/delete-support/${supportId}`)
      .then((response) => {
        if (response.data.status) {
          swal("Deleted", response.data.message, "success", { button: "Done",timer: 1000 });
          getData();
          setShow(false);
        } else {
          swal("Oops", response.data.message, "error", { button: "Done",timer: 1000 });
        }
      })
      .catch((err) => {
        if(err.toString()==="Error: Network Error")
        {
          history.push('/offline')
        }
        else
        {
          history.push('/400')
        }
    })
  }
  return (
    <Col xl="12">
      <Modal
        show={show}
        onHide={() => {
          setShow(false);
        }}
      >
       
        <Modal.Body>
          {deleteStatus?(<h4>Are you sure ! you want to delete <text className="text-danger">{emailUpdate}</text> </h4>):(
            <div className="form-validation">
            <form
              onSubmit={(e) => {
                updateSupport(e);
              }}
            >
              <div className="row">
                <div className="col-sm-2 mt-2">
                  <label>Email</label>
                </div>
                <div className="col-sm-8">
                  <input
                    type="email"
                    required
                    className="form-control"
                    id="val-username"
                    name="val-username"
                    value={emailUpdate}
                    onChange={(e) => {
                      setEmailUpdate(e.target.value);
                    }}
                  />
                </div>
              </div>
              <div className="row mt-4">
                <div className="col-sm-2 mt-2">
                  <label>Phone</label>
                </div>
                <div className="col-sm-8">
                  <input
                    type="number"
                    className="form-control"
                    id="val-username"
                    name="val-username"
                    value={phoneUpdate}
                    onChange={(e) => {
                      setPhoneUpdate(e.target.value);
                    }}
                    required
                  />
                </div>
              </div>
              <input
                className="btn btn-primary mt-4"
                type="submit"
                value="submit"
              />
            </form>
          </div>
          )}
        </Modal.Body>
       {deleteStatus&&(
          <Modal.Footer>
          <Button onClick={()=>{deleteSupport()}}>Delete</Button>
        </Modal.Footer>
       )}
      </Modal>
      {addStatus&&(
        <div className="card" style={{
          color: "white",
          background:
            "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
        }}  >
        <div className="card-header">Add Support</div>
        <div className="card-body">
          <div className="form-validation ml-3">
            <form
              onSubmit={(e) => {
                addSupport(e);
              }}
            >
              <div className="row">
                <div className="mt-2">
                  <label>Email</label>
                </div>
                <div className="col-sm-3">
                  <input
                    type="email"
                    required
                    className="form-control"
                    id="val-username"
                    name="val-username" 
                    value={email}
                    onChange={(e) => {
                      setEmail(e.target.value);
                    }}
                    placeholder="Enter Email"
                  />
                </div>
                <div className="mt-2">
                  <label>Phone</label>
                </div>
                <div className="col-sm-3">
                  <input
                    type="number"
                    className="form-control"
                    id="val-username"
                    name="val-username"
                    value={phone}
                    onChange={(e) => {
                      setPhone(e.target.value);
                    }}
                    placeholder="Enter Phone Number"
                    required
                  />
                </div>
                <div className="col-sm-2">
                  <input
                    className="btn btn-primary"
                    type="submit"
                    value="submit"
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      )}
      {!addStatus&&(
        <div className="card" style={{
          color: "white",
          background:
            "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
        }}>
        <div className="card-header">
          <div className="card-title text-white">
          support List
          </div>
        </div>
        <div className="card-body">
          <Table responsive className="table text-white">
            <thead>
              <tr>
                <th>
                  <strong>Email</strong>
                </th>
                <th>
                  <strong>Phone Number</strong>
                </th>
                <th>
                  <strong>Action</strong>
                </th>
              </tr>
            </thead>
            <tbody>
              {supportData &&
                supportData.map((val) => {
                  return (
                    <tr>
                      <td>{val.Email}</td>
                      <td>{val.Phone}</td>
                      <td>
                        <button
                          onClick={() => {
                            setShow(true);
                            setSupportId(val._id);
                            setEmailUpdate(val.Email);
                            setPhoneUpdate(val.Phone);
                            setDeleteStatus(false)
                          }}
                          className="btn btn-primary"
                        >
                          Update
                        </button>
                        <button
                          onClick={() => {
                            setShow(true);
                            setSupportId(val._id);
                            setDeleteStatus(true)
                            setEmailUpdate(val.Email);
                          }}
                          className="btn btn-primary ml-3"
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </Table>
        </div>
      </div>
      )}
      
    </Col>
  );
}
